import {
  type DropdownItem,
  mapTaxonomiesToDropdownItems,
  type SupportedCountryCode,
} from '@seek/ca-myprofile-utils';
import { useState, useEffect } from 'react';

import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import * as Schema from 'src/types/graphql';

export const useRightToWorkOptionsQuery = () => {
  const { language, zone, isUnifiedSite } = useAppConfig();

  const { data, loading, error, refetch } = useQuery(
    Schema.GetRightToWorkOptionsDocument,
    {
      variables: {
        languageCode: language,
        zone,
        isUnified: isUnifiedSite,
      },
      bypassErrorPageOnFail: true,
    },
  );

  const rightToWorkOptions =
    loading || error ? [] : data?.rightToWorkOptions || [];

  return { rightToWorkOptions, loading, error, refetch };
};

export const useRightToWorkOptionsByCountryCode = (
  countryCode: SupportedCountryCode,
) => {
  const { language, isUnifiedSite } = useAppConfig();
  const [rightToWorkDropdownOptions, setRightToWorkDropdownOptions] = useState<
    DropdownItem[]
  >([]);

  const { rightToWorkOptions, loading, error, refetch } =
    useRightToWorkOptionsQuery();

  useEffect(() => {
    const filteredRtwOptionsByCountryCode = rightToWorkOptions.filter(
      (rtw) => rtw.country.countryCode === countryCode,
    );

    filteredRtwOptionsByCountryCode.map((rtwOptionsByCountryCode) => {
      const mappedRightToWorkOptions = mapTaxonomiesToDropdownItems(
        rtwOptionsByCountryCode.options,
      ) as DropdownItem[];

      setRightToWorkDropdownOptions(mappedRightToWorkOptions);
    });
  }, [
    countryCode,
    rightToWorkOptions,
    error,
    language,
    loading,
    isUnifiedSite,
  ]);

  return { rightToWorkDropdownOptions, error, refetch };
};
